import imgAuthor1 from '../images/avatar/oftv_logo.png';
import img1left from '../images/box-item/collection-item-2.jpg';
import img1right1 from '../images/box-item/collection-item-top-1.jpg';
import img1right2 from '../images/box-item/collection-item-top-2.jpg';
import img1right3 from '../images/box-item/collection-item-bottom-4.jpg';

import imgAuthor2 from '../images/avatar/rhc_logo.png';
import img2left from '../images/box-item/img-collection23.jpg'; // done

import img2right1 from '../images/box-item/img-collection24.jpg'; //done
import img2right2 from '../images/box-item/img-collection10.jpg'; //done
import img2right3 from '../images/box-item/img-collection11.jpg'; // done

import imgAuthor3 from '../images/avatar/4PS_logo.png';
import img3left from '../images/box-item/img-collection-12.jpg'; //done
import img3right1 from '../images/box-item/img-collection18.jpg'; //done
import img3right2 from '../images/box-item/img-collection25.jpg'; //done
import img3right3 from '../images/box-item/img-collection17.jpg'; //done

import imgAuthor4 from '../images/avatar/GbgDash_logo.png';
import img1right4 from '../images/box-item/img-collection8.jpg';
import img2right4 from '../images/box-item/img-collection1.jpg';
import imgtop1 from '../images/box-item/collection-item-4.jpg';
import imgtop2 from '../images/box-item/collection-item-5.jpg';
import imgtop3 from '../images/box-item/collection-item-1.png';

import imgAuthor5 from '../images/avatar/SCHC_logo.png';
import img4left from '../images/box-item/image-box-15.jpg';
import img4right1 from '../images/box-item/image-box-18.jpg';
import img4right2 from '../images/box-item/image-box-14.jpg';
import img4right3 from '../images/box-item/img-collection13.jpg';
import elbowgrease from '../images/avatar/elbowgrease_logo.png';

import img5left from '../images/box-item/img-collection14.jpg';
import img5right1 from '../images/box-item/img-collection15.jpg';
import img5right2 from '../images/box-item/img-collection16.jpg';
import img5right3 from '../images/box-item/img-collection19.jpg';

import TransIntlLogo from '../images/avatar/TransIntl_logo.png';
import img6left from '../images/box-item/image-box-17.jpg';
import img6right1 from '../images/box-item/img-collection22.jpg';
import img6right2 from '../images/box-item/img-collection21.jpg';
import img6right3 from '../images/box-item/img-collection20.jpg';

import img7left from '../images/box-item/image-box-420.png';
import img7right1 from '../images/box-item/collection-item-top-6.jpg';
import img7right2 from '../images/box-item/collection-item-top-7.jpg';
import img7right3 from '../images/box-item/collection-item-bottom-5.jpg';
// itemDetail: '/item-details-01' 2022 portfolio theme item details

import envyesthetics from '../images/avatar/EnvyLogo.png';
import img1lefta from '../images/box-item/collection-item-2a.png.png';
import img1right1a from '../images/box-item/collection-item-top-1.png';
import img1right2a from '../images/box-item/collection-item-top-2a.png';
import img1right3a from '../images/box-item/collection-item-bottom-4.png';

import imgAuthor1v from '../images/avatar/ofi-logo-100x100.png';
import img1leftv from '../images/box-item/collection-item-2v.png';
import img1right1v from '../images/box-item/collection-item-top-1.jpg.png';
import img1right2v from '../images/box-item/collection-item-top-1vv.jpg.png';
import img1right3v from '../images/box-item/collection-item-bottom-4.jpg.png';


const popularCollectionData = [
    {
    title: 'OFI.org',
    imgAuthor: imgAuthor1v,
    name: 'One For Israel Ministry',
    imgleft: img1leftv,
    imgright1: img1right1v,
    imgright2: img1right2v,
    imgright3: img1right3v,
    imgright4: img1right4,
    imgtop: imgtop1,
    wishlist: '100',
    count: 'OneForIsrael.org',
    link: 'https://www.oneforisrael.org/',
    itemDetail: '/item-details-ofi',
  },
  {
    title: 'OF.TV',
    imgAuthor: imgAuthor1,
    name: 'OnlyFansTV',
    imgleft: img1left,
    imgright1: img1right1,
    imgright2: img1right2,
    imgright3: img1right3,
    imgright4: img1right4,
    imgtop: imgtop1,
    wishlist: '100',
    count: 'Goyk Productions',
    link: 'https://of.tv/',
    itemDetail: '/item-details-02',
  },
  {
    title: 'RHC.com',
    imgAuthor: imgAuthor2,
    name: 'Rockhills Church',
    imgleft: img2left,
    imgright1: img2right1,
    imgright2: img2right2,
    imgright3: img2right3,
    imgright4: img1right4,
    imgtop: imgtop2,
    wishlist: '220',
    count: 'My rockhills Church',
    link: 'https://www.myrockhillschurch.com/',
    itemDetail: '/ItemDetails03',
  },
  {
    title: '4 Point Crane',
    imgAuthor: imgAuthor3,
    name: '4Point',
    imgleft: img3left,
    imgright1: img3right1,
    imgright2: img3right2,
    imgright3: img3right3,
    imgright4: img2right4,
    imgtop: imgtop3,
    wishlist: '90',
    count: '4Point LLC',
    link: 'https://4pointCrane.com/',
    itemDetail: '/item-details-01',
  },
    {
    title: 'Southern California Health Center',
    imgAuthor: imgAuthor5,
    name: 'Irvine Chiropractor',
    imgleft: img5left,
    imgright1: img5right1,
    imgright2: img5right2,
    imgright3: img5right3,
    // imgright4: img1right4,
    imgtop: imgtop2,
    wishlist: '100',
    count: 'Southern California Health Center',
    link: 'https://www.irvinechiropractor.com/',
    itemDetail: '/item-details-04',
  },
  {
    title: 'Envy Dental, Implants & Esthetics',
    imgAuthor: envyesthetics,
    name: 'Envy Dental & Esthetics',
    imgleft: img1lefta,
    imgright1: img1right1a,
    imgright2: img1right2a,
    imgright3: img1right3a,
    imgright4: img1right4,
    imgtop: imgtop1,
    wishlist: '100',
    count: 'Envy Dental & Esthetics',
    link: 'https://envyesthetics.net/',
    itemDetail: '/itemDetails03a',
  },
  {
    title: 'TransIntl',
    imgAuthor: TransIntlLogo,
    name: 'Transintl.com',
    imgleft: img7left,
    imgright1: img7right1,
    imgright2: img7right2,
    imgright3: img7right3,
    // imgright4: img1right4,
    imgtop: imgtop1,
    wishlist: '100',
    count: 'TransIntl LLC',
    link: 'https://www.transintl.com/',
    itemDetail: '/item-details-05',
  },
  {
    title: 'GarbageDash',
    imgAuthor: imgAuthor4,
    name: 'GarbageDash',
    imgleft: img4left,
    imgright1: img4right1,
    imgright2: img4right2,
    imgright3: img4right3,
    imgright4: img1right4,
    imgtop: imgtop1,
    wishlist: '145',
    count: 'Garbagedash LLC',
    link: 'https://www.yelp.com/biz/garbagedash-corona',
    itemDetail: '/item-details-02',
  },
  {
    title: 'ElbowGrease AutoDetail',
    imgAuthor: elbowgrease,
    name: 'ElbowGrease AutoDetail',
    imgleft: img6left,
    imgright1: img6right1,
    imgright2: img6right2,
    imgright3: img6right3,
    imgright4: img2right4,
    imgtop: imgtop3,
    wishlist: '220',
    count: 'Elbowgrease Auto detail LLC',
    itemDetail: '/item-details-02',
  },

  //   {
  //     title: 'Colorful Abstract',
  //     imgAuthor: imgAuthor2,
  //     name: 'Mason Woodward',
  //     imgleft: img2left,
  //     imgright1: img2right1,
  //     imgright2: img2right2,
  //     imgright3: img2right3,
  //     imgright4: img1right4,
  //     imgtop: imgtop2,
  //     wishlist: '220',
  //     count: '26 item products',
  //   },
  //   {
  //     title: 'Modern Art Collection',
  //     imgAuthor: imgAuthor3,
  //     name: 'Freddie Carpenter',
  //     imgleft: img3left,
  //     imgright1: img3right1,
  //     imgright2: img3right2,
  //     imgright3: img3right3,
  //     imgright4: img2right4,
  //     imgtop: imgtop3,
  //     wishlist: '90',
  //     count: '26 item products',
  //   },
  //   {
  //     title: 'Creative Art Collection',
  //     imgAuthor: imgAuthor1,
  //     name: 'Ralph Garraway',
  //     imgleft: img4left,
  //     imgright1: img4right1,
  //     imgright2: img4right2,
  //     imgright3: img4right3,
  //     imgright4: img1right4,
  //     imgtop: imgtop1,
  //     wishlist: '145',
  //     count: '12 item products',
  //   },
  //   {
  //     title: 'Colorful Abstract',
  //     imgAuthor: imgAuthor2,
  //     name: 'Mason Woodward',
  //     imgleft: img5left,
  //     imgright1: img5right1,
  //     imgright2: img5right2,
  //     imgright3: img5right3,
  //     imgright4: img1right4,
  //     imgtop: imgtop2,
  //     wishlist: '100',
  //     count: '26 item products',
  //   },
  //   {
  //     title: 'Modern Art Collection',
  //     imgAuthor: imgAuthor3,
  //     name: 'Freddie Carpenter',
  //     imgleft: img6left,
  //     imgright1: img6right1,
  //     imgright2: img6right2,
  //     imgright3: img6right3,
  //     imgright4: img2right4,
  //     imgtop: imgtop3,
  //     wishlist: '220',
  //     count: '26 item products',
  //   },
];

export default popularCollectionData;
